import type { InputHTMLAttributes, FC } from 'react';

import { cn } from './cn.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input: FC<InputProps> = ({ className, ...rest }) => (
  <input
    className={cn(
      'h-[34px] w-full rounded-[7px] border border-ink-200 bg-white px-3 text-[13px] text-ink-900',
      'placeholder:text-ink-400 focus-visible:border-brand-green focus-visible:ring-2',
      'focus-visible:ring-brand-green-50 focus-visible:outline-none',
      className,
    )}
    {...rest}
  />
);
